import React, { useState } from 'react';
import Sidebar from '../Sidebar'
import './styles.scss';
import { Container, CssBaseline } from "@material-ui/core";


type LayoutProps = {
    children: React.ReactNode
}
export const Layout: React.FC<LayoutProps> = ({children}) => {
    const [collapsed, setCollapsed] = useState(false);

    return (
        <React.Fragment>
            <CssBaseline/>
            <Sidebar collapsed={collapsed} setCollapsed={setCollapsed}/>
            <Container
                maxWidth={false}
                style={{
                    transition: 'margin-left 0.3s ease-in-out',
                    paddingLeft: collapsed ? '130px' : '220px', // Ajuste os valores conforme necessário
                }}
            >
                <img className={`vector-img ${collapsed ? 'collapsed' : ''}`} src="/vector.svg" alt={''}/>
                {children}
            </Container>
        </React.Fragment>

    );
};

export default Layout;
